import React, { useEffect } from 'react';

import { FreecodeContextRunProvider } from 'components/FreecodePage/FreecodeContextRun';
import { manageZendeskButton } from 'functions/zendesk';
import { FreecodeContextLayoutProvider } from 'components/FreecodePage/FreecodeContextLayout';
import { FreecodeContextDataProvider } from 'components/FreecodePage/FreecodeContextData';
import { useAppContext } from 'hooks/useContext';

export default function FreecodeRoute({ component: Component }) {
  const { setDarkModeSupported } = useAppContext();
  useEffect(() => manageZendeskButton('hide'), []);

  useEffect(() => {
    setDarkModeSupported(true);
    return () => setDarkModeSupported(false);
  }, [setDarkModeSupported]);

  useEffect(() => {
    if (!document?.documentElement?.style) return;
    const preStyle = document.documentElement.style['overscroll-behavior-y'];
    document.documentElement.style['overscroll-behavior-y'] = 'none';
    return () => (document.documentElement.style['overscroll-behavior-y'] = preStyle);
  });

  return (
    <FreecodeContextLayoutProvider>
      <FreecodeContextDataProvider>
        <FreecodeContextRunProvider>
          <Component />
        </FreecodeContextRunProvider>
      </FreecodeContextDataProvider>
    </FreecodeContextLayoutProvider>
  );
}
